import React from 'react'
import TopBar from '../components/menu/TopBar'
import AppintakeCard from '../components/appintake/AppintakeCard'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { language } from '../stores/slices/languageSlice'

function PreQualDenial() {
    const preQualFailurQuestions = useSelector(state => state.preQualValidateSlice.failiure)
    const selectedLanguage = useSelector(language).PreQualDenial

    return (
        <div className="content">
            <TopBar />
            <div className="g-col-12 g-col-xxl-9">
                <AppintakeCard flow={{ flow: 'Application' }} />
                {/* <!-- BEGIN: Wizard Layout --> */}
                <div className="intro-y box py-1 py-sm-4 mt-5">
                    <div className="d-flex justify-content-center">
                        <div className="px-5 mt-1">
                            <div className="fw-medium text-center fs-lg" data-testid="heading">{selectedLanguage.heading}</div>
                        </div>
                    </div>
                </div>
                <div className="intro-y box py-1 py-sm-2 mt-5 bg-danger g-col-6 g-col-xxl-6">
                    <div className="d-flex justify-content-center">
                        <div className="mt-1">
                            <div className="fw-medium text-center fs-lg" data-testid="heading">{selectedLanguage.reason} {preQualFailurQuestions?.fundName}</div>
                        </div>
                    </div>
                </div>
                <div className="grid columns-12 gap-4 gap-y-5 mt-5" >
                    {preQualFailurQuestions?.PreQualQuestionsList.map((prequalQuestion, i) => {
                        return <React.Fragment>
                            <div className={`intro-y g-col-1 g-col-md-2 g-col-xl-2 px-8 `}></div>
                            <div className={`intro-y g-col-4 g-col-md-4 g-col-xl-4 py-1`}>{prequalQuestion.Question}</div>
                            <div className={`intro-y g-col-3 g-col-md-2 g-col-xl-2 py-1`}>{prequalQuestion.AnswerType == "Drop-down" ? prequalQuestion.Answer : prequalQuestion.YesNoAnswer}</div>
                            <div className={`intro-y g-col-3 g-col-md-2 g-col-xl-2 text-center py-1`}><p className={`${prequalQuestion.BooleanVal1 ? "bg-success" : "bg-danger"}`}>{prequalQuestion.BooleanVal1 ? "sucess" : "failed"}</p></div>
                            <div className={`intro-y g-col-1 g-col-md-2 g-col-xl-2 px-8 `}></div>
                        </React.Fragment>
                    })}
                </div>
                <div className="grid columns-12 gap-4 gap-y-5 mt-5 p">
                    <div className={`intro-y g-col-1 g-col-md-2 g-col-xl-2 px-8 `}></div>
                    <p className={`intro-y g-col-10 g-col-md-8 g-col-xl-8 `}>{preQualFailurQuestions?.message}</p>
                </div>
                <div className="d-flex justify-content-center">
                    <Link to="/createApp" className='btn btn-danger'>{selectedLanguage.closeBtn}</Link>
                </div>
            </div>
        </div>
    )
}

export default PreQualDenial